import { render, staticRenderFns } from "./NavbarDesktop.vue?vue&type=template&id=34a987c0&scoped=true&"
import script from "./NavbarDesktop.vue?vue&type=script&lang=js&"
export * from "./NavbarDesktop.vue?vue&type=script&lang=js&"
import style0 from "./NavbarDesktop.vue?vue&type=style&index=0&id=34a987c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a987c0",
  null
  
)

export default component.exports